import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import styles from './styles.scss';


const MAX_FILE_SIZE = 4 * 1024 * 1024; // bytes

const DropSection = ({ accept, onDrop, multiple, maxSize }) => (
  <Dropzone
    accept={accept}
    onDrop={onDrop}
    multiple={multiple}
    maxSize={maxSize || MAX_FILE_SIZE}
    activeClassName={styles.dropzone_drag}
    className={styles.dropzone}>
    <div className={`d-table ${styles.container}`}>
      <span className={`d-table-cell ${styles.label}`}>
        <i className={`fa fa-cloud-upload ${styles.uploadIcon}`} /> <br />
        Drop file here <br /> or <span className={styles.uploadLink}>click to upload</span>
      </span>
    </div>
  </Dropzone>
);

DropSection.propTypes = {
  accept: PropTypes.string,
  onDrop: PropTypes.func,
  multiple: PropTypes.bool,
  maxSize: PropTypes.number
};

export default DropSection;


// WEBPACK FOOTER //
// src/components/shared/DropSection/index.jsx